import { PRIMARY_LOCATION_FACING, type LocationStorableFacing } from "@/lib/locations-api"
import type { GenerationJobRow } from "@/types/workspace"

/** Любая генерация базового референса локации (для списка слева). */
export function locationListReferenceBusy(jobs: GenerationJobRow[], locationId: number) {
  const id = Number(locationId)
  return jobs.some(
    (j) =>
      (j.status === "queued" || j.status === "processing") &&
      Number(j.location_id) === id &&
      (j.location_variant_id ?? null) === null &&
      (j.job_kind === "location_reference" || j.job_kind === "sketch_edit"),
  )
}

export function locationReferenceJob(
  jobs: GenerationJobRow[],
  locationId: number,
  facing: LocationStorableFacing,
): GenerationJobRow | null {
  const id = Number(locationId)
  const f = facing ?? PRIMARY_LOCATION_FACING
  return (
    jobs.find(
      (j) =>
        (j.status === "queued" || j.status === "processing") &&
        Number(j.location_id) === id &&
        (j.location_variant_id ?? null) === null &&
        (j.location_facing ?? PRIMARY_LOCATION_FACING) === f &&
        (j.job_kind === "location_reference" || j.job_kind === "sketch_edit"),
    ) ?? null
  )
}

export function locationReferenceBusy(jobs: GenerationJobRow[], locationId: number, facing: LocationStorableFacing) {
  return locationReferenceJob(jobs, locationId, facing) != null
}

export function variantReferenceJob(
  jobs: GenerationJobRow[],
  locationId: number,
  variantId: number,
  facing: LocationStorableFacing,
): GenerationJobRow | null {
  const lid = Number(locationId)
  const vid = Number(variantId)
  const f = facing ?? PRIMARY_LOCATION_FACING
  return (
    jobs.find(
      (j) =>
        (j.status === "queued" || j.status === "processing") &&
        Number(j.location_id) === lid &&
        Number(j.location_variant_id) === vid &&
        (j.location_facing ?? PRIMARY_LOCATION_FACING) === f &&
        (j.job_kind === "location_reference" || j.job_kind === "sketch_edit"),
    ) ?? null
  )
}

export function variantReferenceBusy(
  jobs: GenerationJobRow[],
  locationId: number,
  variantId: number,
  facing: LocationStorableFacing,
) {
  return variantReferenceJob(jobs, locationId, variantId, facing) != null
}
